import DashboardTablePagination from 'features/dashboard/table/DashboardTablePagination'
import ColumnSelect from 'features/dashboard/table/config/ColumnSelect'
import OnOffButtons from 'features/dashboard/operation/onOff/OnOffButtons'
import DeleteButton from 'features/dashboard/operation/delete/DeleteButton'
import KeywordDownloadButton from 'features/dashboard/operation/download/KeywordDownloadButton'
import KeywordLandingUrlEditSelect from 'features/dashboard/operation/keywordLandingUrlEdit/KeywordLandingUrlEditSelect'
import KeywordBiddingStrategyEditSelect from 'features/dashboard/operation/keywordBiddingStrategyEdit/KeywordBiddingStrategyEditSelect'
import KeywordCopyButton from 'features/dashboard/operation/keywordCopy/KeywordCopyButton'
import CreateKeywordButton from 'features/dashboard/operation/createKeyword/CreateKeywordButton'

const KeywordTableHeader = () => (
  <div className="set_head">
    <div className="f_left">
      <div className="single_wrap">
        <CreateKeywordButton />
      </div>
      <div className="single_wrap">
        <KeywordCopyButton />
      </div>
      <div className="single_wrap">
        <OnOffButtons />
      </div>
      <div className="single_wrap">
        <KeywordBiddingStrategyEditSelect />
      </div>
      <div className="single_wrap">
        <KeywordLandingUrlEditSelect />
      </div>
      <div className="single_wrap">
        <DeleteButton />
      </div>
    </div>
    <div className="f_right">
      <div className="single_wrap">
        <DashboardTablePagination />
      </div>
      <div className="single_wrap">
        <ColumnSelect />
      </div>
      <div className="single_wrap">
        <KeywordDownloadButton />
      </div>
    </div>
  </div>
)
export default KeywordTableHeader
